import { useQuery } from "react-query";
import { useEffect, useState } from "react";
import dayjs from "dayjs";

export interface ICouponVouchersDetailInfo {
  couponNo: number;
  couponBalance: number;
  used: number;
  useDate: number;
  deductTask: number;
  deduckAmount: number;
  getWay: number;
  effectiveDate: number;
  expireDate: number;
}

export interface ICouponVouchersInfo {
  effectiveVoucher: ICouponVouchersDetailInfo[];
  invalidVoucher: ICouponVouchersDetailInfo[];
}

export function useVocherInfo() {
  const [vocherInfo, setVocherInfo] = useState<ICouponVouchersInfo>();
  const [recentExpireDate, setRecentExpireDate] = useState("");

  const { data } = useQuery<ICouponVouchersInfo>(
    "/api/rendering/pay/recharge/queryUserVouchers"
  );

  useEffect(() => {
    if (!data) return;
    setVocherInfo(data);
    const effectiveVocherList = data.effectiveVoucher;
    const expireDate = effectiveVocherList.length
      ? dayjs(
          Math.min(...effectiveVocherList.map((item) => item.expireDate))
        ).format("YYYY-MM-DD")
      : "-";
    setRecentExpireDate(expireDate);
  }, [data]);

  return { vocherInfo, recentExpireDate };
}
